import styled from 'styled-components';
import { EBrand } from '../..';
import { Dropdown as Drop } from '../Dropdown/Dropdown';

export const Select = styled.div<{ showArrow: boolean }>`
  border-radius: ${({ theme }) => theme.borderRadius};
  border: ${({ theme }) => (theme.brand === EBrand.Mac ? '1px solid #ccc' : '1px solid black')};
  width: 100%;
  padding: ${({ showArrow }) => (showArrow ? '7px 40px 7px 10px' : '7px')};
  overflow: hidden;
  position: relative;
  display: block;
  text-align: center;
`;

export const Value = styled.span`
  text-transform: uppercase;
  letter-spacing: 0.3px;
  white-space: nowrap;
  overflow: hidden;
  width: auto;
  text-overflow: ellipsis;
  font-size: 14px;
  display: inline-block;
  height: 100%;
  vertical-align: middle;
`;

export const Arrow = styled.span<{ active: boolean }>`
  display: inline-block;
  position: absolute;
  right: 12px;
  top: calc(50% - 10px);
  transition: transform 0.2s;
  transform: ${({ active }) => (active ? 'rotate(90deg)' : 'rotate(-90deg)')};
`;

export const Item = styled.div`
  display: flex;
  padding: 5px 6px;
  align-items: center;
  background-color: #fff;
  cursor: pointer;
  z-index: 102;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 0px; /* Remove scrollbar space */
    background: transparent; /* Optional: just make scrollbar invisible */
  }
  scrollbar-width: none;
  &:hover {
    background-color: #4c91e3;
  }
`;

export const ItemValue = styled.span`
  text-transform: uppercase;
  letter-spacing: 0.3px;
  padding: 5px;
  font-size: 12px;
  display: inline-block;
`;

export const Dropdown = styled(Drop)<{ itemsNumber: number; positionTop: boolean }>`
  .dropdown-list {
    border: 1px solid #ccc !important;
    border-radius: ${({ theme }) => theme.borderRadius};
    z-index: 103;

    top: ${({ itemsNumber, positionTop }) => (positionTop ? `${-itemsNumber * 38}px` : 'unset')};

    div {
      max-height: 150px; // 5 items
      ::-webkit-scrollbar {
        width: 0px; /* Remove scrollbar space */
        background: transparent; /* Optional: just make scrollbar invisible */
      }
      scrollbar-width: none;
    }
  }
`;
